export default __webpack_public_path__ + "static/assets/no_data.2b9e33b1.png";